var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.35,
    height: 20.002,
    viewBox: "0 0 19.35 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-2 -1.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31454",
    "data-name": "Path 31454",
    d: "M16.686,2.421h-.76V1.7a.622.622,0,0,0-1.244,0v.72H10.915V1.7a.622.622,0,1,0-1.244,0v.72H5.9V1.7a.622.622,0,1,0-1.244,0v.72H3.9A1.9,1.9,0,0,0,2,4.322V6.463H18.586V4.322A1.9,1.9,0,0,0,16.686,2.421Z",
    transform: "translate(0)",
    fill: "#8a8989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31455",
    "data-name": "Path 31455",
    d: "M27.856,17.348a1.685,1.685,0,0,0-2.391,0l-.8.8,2.393,2.393.795-.795a1.694,1.694,0,0,0,0-2.4Z",
    transform: "translate(-7.003 -4.872)",
    fill: "#072430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31456",
    "data-name": "Path 31456",
    d: "M21.514,19.79,17.32,23.978a.566.566,0,0,0-.166.325l-.318,1.852a.608.608,0,0,0,.7.7l1.852-.311a.618.618,0,0,0,.332-.173l4.188-4.188Z",
    transform: "translate(-4.581 -5.78)",
    fill: "#072430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31457",
    "data-name": "Path 31457",
    d: "M17.726,14.617a2.689,2.689,0,0,1,.86-.583V10.375H2V22.051a1.9,1.9,0,0,0,1.9,1.9h7.436a1.623,1.623,0,0,1-.1-.878l.318-1.855a1.605,1.605,0,0,1,.486-.912L16.6,15.754Zm-7.682,6.245H5.352a.622.622,0,1,1,0-1.244h4.692a.622.622,0,1,1,0,1.244ZM13,17.524H5.352a.622.622,0,1,1,0-1.244H13a.622.622,0,1,1,0,1.244Zm2.236-3.33H5.355a.622.622,0,1,1,0-1.244h9.877a.622.622,0,0,1,0,1.244Z",
    transform: "translate(0 -2.872)",
    fill: "#8a8989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.56e4d1264718bfc5c630cb2bf459945f.svg";
export { ForwardRef as ReactComponent };